import { Box, HStack, VStack } from "@chakra-ui/react";
import { colors } from "goi_common";

/**
 * 전국 비용 범위(MIN_PRICE~MAX_PRICE) 안에서
 * 이 장례식장의 예상 비용 구간(min~max)을 주황 막대로 강조.
 *
 * 출처: platform.goifuneral.co.kr/containers/MatchContainer/.../ExpectedPriceRangeBar
 * - 동일 컴포넌트를 parlor.goi에서도 재사용하기 위해 복사.
 */

interface ExpectedPriceRangeBarProps {
  min: number;
  max: number;
  MIN_PRICE: number;
  MAX_PRICE: number;
}

export const ExpectedPriceRangeBar = ({
  min,
  max,
  MIN_PRICE,
  MAX_PRICE,
}: ExpectedPriceRangeBarProps) => {
  const getBarPosition = (price: number): number => {
    if (MAX_PRICE === MIN_PRICE) {
      return 0;
    }
    return ((price - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;
  };

  return (
    <VStack width="100%" spacing="24px" alignItems="stretch">
      <Box borderRadius="12px" bg={colors.gray50} px="24px" pb="14px" pt="40px">
        <VStack spacing="16px" alignItems="stretch">
          <VStack width="100%" spacing="12px">
            <Box position="relative" width="100%" height="8px">
              <Box
                width="100%"
                height="100%"
                bg={colors.gray200}
                borderRadius="full"
              />

              <Box
                position="absolute"
                top="0"
                height="100%"
                bg={colors.orange650}
                transition="all 0.5s ease"
                left={`${getBarPosition(min)}%`}
                width={`${getBarPosition(max) - getBarPosition(min)}%`}
              >
                <div
                  className="caption_12_sb orange650"
                  css={{
                    position: "absolute",
                    top: "-24px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    whiteSpace: "nowrap",
                    transition: "all 0.5s ease",
                  }}
                >
                  예상 비용 범위
                </div>
                <Box
                  position="absolute"
                  left="0px"
                  top="50%"
                  transform="translateY(-50%)"
                  width="2px"
                  height="16px"
                  bg={colors.orange650}
                />
                <Box
                  position="absolute"
                  right="0px"
                  top="50%"
                  transform="translateY(-50%)"
                  width="2px"
                  height="16px"
                  bg={colors.orange650}
                />
              </Box>
            </Box>

            <HStack
              width="100%"
              justifyContent="space-between"
              color={colors.gray400}
            >
              <div className="caption_12_m gray600">
                {MIN_PRICE.toLocaleString()}만원
              </div>
              <div className="caption_12_m gray600">
                {MAX_PRICE.toLocaleString()}만원
              </div>
            </HStack>
            <div className="caption_12_m gray600">
              실제 비용은 상황에 따라 달라질 수 있습니다.
            </div>
          </VStack>
        </VStack>
      </Box>
    </VStack>
  );
};
